import React from "react";
import { Button, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "../../../components/Logo";

const InvalidInvitation = () => {
  const navigate = useNavigate();
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: "100vh" }}
      spacing={2}
    >
      <Grid item>
        <Logo height={100} width={100} style={{ marginBottom: "16px" }} />
      </Grid>
      <Grid item>
        <Typography variant="h4" gutterBottom>
          Invitación Inválida
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          variant="body1"
          gutterBottom
          paddingRight={15}
          paddingLeft={15}
        >
          La invitación que has recibido es inválida. Por favor, ponete en
          contacto con el administrador del workspace.
        </Typography>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/")}
        >
          Volver al Inicio
        </Button>
      </Grid>
    </Grid>
  );
};

export default InvalidInvitation;
